
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("93vxT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1ba2093086aa62c8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $3dcf9d38d691d4f3$export$2e2bcd8739ae039 = {
    'cross-flow-support.back-to-all-products': 'Back to all apps',
    'cross-flow-support.close': 'Close',
    'cross-flow-support.product-store': 'App store'
};


var $1ba2093086aa62c8$export$2e2bcd8739ae039 = (0, $3dcf9d38d691d4f3$export$2e2bcd8739ae039);

});


//# sourceMappingURL=en.85974bcd.js.map
